exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.example-multiple label.btn {\n  margin-bottom: 0;\n  margin-right: 1rem;\n}\n.example-multiple .upload {\n  margin-bottom: 1rem;\n}\n", ""]);

// exports
